module.exports = __webpack_public_path__ + "static/pop_xiaoai.6ef75607.png";